export default "__VITE_ASSET__BSoQq669__"